module.exports = __webpack_public_path__ + "static/media/RationalDisplay-Medium.c81a94f3.otf";